import script from "./PixKeyStatusPill.vue?vue&type=script&setup=true&lang=js"
export * from "./PixKeyStatusPill.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__